import { CalendarEvent } from "toptaal-shared"

export function canCancelEvent(selectedEvent: CalendarEvent | null): boolean {
  if (!selectedEvent || !selectedEvent.start) return false
  const eventDateTime = new Date(selectedEvent.start)
  if (eventDateTime <= new Date()) return false

  if (selectedEvent.type === "intake") {
    return selectedEvent.studentStatus === "registered"
  }

  return ["registered", "present"].includes(selectedEvent?.studentStatus ?? "")
}
